<script setup lang="ts">
export interface IconEqualizer {
  bgColor?: string;
}

const props = withDefaults(defineProps<IconEqualizer>(), {
  bgColor: "var(--base-secondary-color)",
});
</script>

<template>
  <div class="equalizer">
    <div class="column-1" :style="{ backgroundColor: props.bgColor }" />
    <div class="column-2" :style="{ backgroundColor: props.bgColor }" />
    <div class="column-3" :style="{ backgroundColor: props.bgColor }" />
  </div>
</template>

<style lang="scss">
//FIXME: styles
.equalizer {
  @apply h-[16px] w-[16px] flex justify-between;
  align-items: flex-end;

  .column-1 {
    @apply relative w-[4px] h-[16px];
    animation: go-up-down 0.4s infinite alternate;
  }

  .column-2 {
    @apply relative w-[4px] h-[16px] mx-[1px];
    animation: go-up-down 0.6s infinite alternate;
  }

  .column-3 {
    @apply relative w-[4px] h-[16px];
    animation: go-up-down 0.5s infinite alternate;
  }

  @keyframes go-up-down {
    0% { height: 0px; }
    100% { height: 16px; }
  }
}
</style>
